import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';

import dhid from '../../../dhid';
import styles from '../account.scss';
import redirectToESLLogin from './RedirectToESL';

const propTypes = {
  client: PropTypes.shape({
    name: PropTypes.string,
  }),
  userError: PropTypes.shape({
    message: PropTypes.string,
    json: PropTypes.shape({}),
  }),
  match: PropTypes.shape({
    params: PropTypes.shape({
      returnHash: PropTypes.string,
    }),
  }),
  location: PropTypes.shape({
    search: PropTypes.string,
  }),
};

class Login extends React.PureComponent {
  render() {
    if (!dhid && typeof window !== 'undefined') {
      return (
        <div className={styles.error}>
          The DreamHack login is currently unavailable. Please try again later.
        </div>
      );
    }

    // Start ESL Redirect
    redirectToESLLogin();
    return <></>;
  }
}

Login.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    loading: state.getIn(['user', 'loading']) || state.getIn(['auth', 'loading']),
    userError: state.getIn(['user', 'error']),
    authError: state.getIn(['auth', 'error']),
  };
}

export default connect(mapStateToProps)(Login);
